import api from './api';

export async function getProducts() {
  const { data } = await api.get('/product');
  return data;
}

export async function createProduct(payload) {
  const { data } = await api.post('/product', payload);
  return data;
}

export async function updateProduct(id, payload) {
  const { data } = await api.put(`/product/${id}`, payload);
  return data;
}

export async function updateProductPricing(id, payload) {
  const { data } = await api.put(`/product/${id}/pricing`, payload);
  return data;
}

export async function getProductInventoryByBranch(branchId) {
  const { data } = await api.get(`/product/inventory/branch/${branchId}`);
  return data;
}
